import { styled, Typography, TypographyProps } from '@mui/material';

export const StyledTypography = styled(Typography)<TypographyProps<'a'>>(
  ({ theme }) => ({
    fontWeight: 700,
    textDecoration: 'none',
    color: theme.palette.grey[50],
    marginLeft: theme.spacing(5),
    '&:hover': {
      color: theme.palette.primary.main,
    },
  })
);
